import React from "react";
import { VisuallyHidden } from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Carousel as BaseCarousel } from "../Carousel";
import { Clickable, IconButton } from "../Clickables";

import styles from "./GoodcookCarousel.module.scss";

type Props = React.ComponentProps<typeof BaseCarousel> & {
    dotsClassName?: string;
    controlsClassName?: string;
};

export function Carousel(props: Props) {
    return (
        <BaseCarousel
            {...props}
            containerProps={{
                ...props.containerProps,
                className: concatClassNames([
                    props.containerProps?.className,
                    styles.root,
                ]),
            }}
            scrollContainerProps={{
                ...props.scrollContainerProps,
                className: concatClassNames([
                    props.scrollContainerProps?.className,
                    styles.scrollContainer,
                ]),
            }}
            controls={({ allVisible }) => {
                if (allVisible) {
                    return null;
                }
                return (
                    <div
                        className={concatClassNames([
                            styles.controls,
                            props.controlsClassName,
                        ])}
                    >
                        <IconButton
                            className={styles.arrowLeft}
                            slot="previous"
                            icon="caret"
                            label="Previous slide"
                        />
                        <IconButton
                            className={styles.arrowRight}
                            slot="next"
                            icon="caret"
                            label="Next slide"
                        />
                    </div>
                );
            }}
            dots={({ allVisible, slideCount }) => {
                if (allVisible) {
                    return null;
                }
                return (
                    <div
                        className={concatClassNames([
                            styles.dots,
                            props.dotsClassName,
                        ])}
                    >
                        {Array.from({ length: slideCount }).map((_, i) => {
                            // Not sure why this isn't getting the children from the slot but oh well!
                            return (
                                <Clickable key={i} slot={`slide-${i}`}>
                                    <VisuallyHidden>{`${i + 1} of ${slideCount}`}</VisuallyHidden>
                                </Clickable>
                            );
                        })}
                    </div>
                );
            }}
            loop={false}
        />
    );
}
